import {TSMap} from "typescript-map";
import {CountryInfo} from "platform/protocol/common/CountryInfo";

export class BoardState {

    private static _instance: BoardState;
    private _phoneCodePerCountry: TSMap<string, CountryInfo> = new TSMap();
    private _signUpSocialToken: string;
    private _urlError: string;

    private constructor() {
    }

    public static instance(): BoardState {
        return this._instance || (this._instance = new this());
    }

    public addCountry(ci: CountryInfo): void {
        this._phoneCodePerCountry.set(ci.PhoneCode, ci);
    }

    public getCountryByPhoneCode(phoneCode: string): CountryInfo {
        return this._phoneCodePerCountry.get(phoneCode);
    }

    public get signUpSocialToken(): string {
        return this._signUpSocialToken;
    }

    public set signUpSocialToken(value: string) {
        this._signUpSocialToken = value;
    }

    public get urlError(): string {
        return this._urlError;
    }

    public set urlError(value: string) {
        this._urlError = value;
    }
}
